import styled, { css } from 'styled-components'
import { PRIMARY_TEXT, GRAY6, GRAY5, PURPLE, BLACK_RGB } from 'constants/colors'

export const EditorWrapper = styled.div<{ readOnly: boolean }>`
  ${({ readOnly }) =>
    readOnly
      ? css`
          .ql-container.ql-snow {
            border: none;
          }

          .ql-editor {
            padding: 0;
          }
        `
      : css`
          .ql-snow .ql-tooltip {
            z-index: 1;
            margin-left: 100px;
          }

          .quill {
            margin-bottom: 16px;
          }

          .ql-editor.ql-blank::before {
            color: ${GRAY5};
          }

          .ql-snow * {
            color: ${PRIMARY_TEXT};
          }

          .ql-toolbar.ql-snow,
          .ql-container.ql-snow {
            border-color: ${GRAY6};
          }

          .ql-snow.ql-toolbar {
            button:hover,
            button:focus,
            button.ql-active,
            .ql-picker-label:hover,
            .ql-picker-label.ql-active,
            .ql-picker-item:hover,
            .ql-picker-item.ql-selected {
              color: ${PURPLE};

              .ql-stroke {
                stroke: ${PURPLE};
              }
            }
          }
        `}
`

export const EditorTitle = styled.span`
  color: rgba(${BLACK_RGB}, 0.54);
  font-size: 12px;
  font-weight: 400;
`
